import React from 'react';
import { Countdown } from './Countdown';
export function UrgencySection() {
  return <section className="bg-petrol-dark px-4 py-7 sm:px-6 sm:py-9" data-id="element-255" data-mp="2sit1phcgikic">
      <div className="mx-auto max-w-3xl text-center" data-id="element-256" data-mp="2sggbyi0gj5uq">
        <p className="inline-block rounded-full bg-gold px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.16em] text-petrol-dark sm:text-xs" data-id="element-257" data-mp="36azgp03vilg7">
          Offre à durée limitée
        </p>
        <h2 className="mt-2.5 text-lg font-extrabold text-white sm:text-2xl" data-id="element-258" data-mp="3g6u4saqv98qd">
          Le prix de lancement se termine dans :
        </h2>
        <div className="mt-3" data-id="element-259" data-mp="3bbes3m4lhivj">
          <Countdown data-id="element-260" data-mp="3p9bpulusbvbs" />
        </div>
        <p className="mt-3 text-[13px] leading-snug text-cream/80 sm:text-sm" data-id="element-261" data-mp="3p8a49ng57qft">
          Après cela, le prix pourra augmenter et les bonus stratégiques pourront ne plus être
          inclus.
        </p>
        <ul className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-262" data-mp="1uvare235dac8">
          <li className="rounded-full border border-gold/50 px-2.5 py-1 font-display text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-263" data-mp="1qtz25xo6qr4k">
            Offre de lancement
          </li>
          <li className="rounded-full border border-white/25 px-2.5 py-1 font-display text-[10px] font-bold uppercase tracking-widest text-white/80" data-id="element-264" data-mp="2xs7xfze7ap9g">
            Disponibilité limitée
          </li>
        </ul>
      </div>
    </section>;
}